module.exports = __webpack_public_path__ + "static/media/info-dak.fefe9beb.png";